import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apiGet } from '../api';
import { canWriteProjects } from '../permissions';
import './DashboardPage.css';

function DashboardPage({ user }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [metrics, setMetrics] = useState({
    totalProjects: 0,
    activeRuns: 0,
    totalRuns: 0,
    passRate: 0
  });

  useEffect(() => {
    fetchProjects();
    fetchMetrics();
  }, []);

  const fetchProjects = async () => {
    try {
      const data = await apiGet('/projects');
      setProjects(data);
      setMetrics(prev => ({
        ...prev,
        totalProjects: data.length
      }));
    } catch (err) {
      setError('Failed to load projects');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchMetrics = async () => {
    try {
      const data = await apiGet('/reports/overview');
      setMetrics(prev => ({
        ...prev,
        totalProjects: data.totalProjects ?? prev.totalProjects,
        totalRuns: data.totalRuns ?? 0,
        activeRuns: data.activeRuns ?? 0,
        passRate: data.passRate ?? 0
      }));
    } catch (err) {
      console.error('Error loading dashboard metrics:', err);
    }
  };

  return (
    <div className="dashboard-page">
      <div className="container">
        <div className="dashboard-title-row">
          <div>
            <h1>Dashboard</h1>
            <p className="welcome">Welcome back, {user?.username}!</p>
          </div>
          {canWriteProjects(user) && (
            <Link to="/projects/new" className="btn btn-primary" style={{ textDecoration: 'none' }}>
              + New Project
            </Link>
          )}
        </div>

        {error && <div className="error-banner">{error}</div>}

        {/* Overview: 4 stat cards in a row */}
        {!loading && (
          <div className="dashboard-overview">
            <div className="dashboard-metrics">
              <div className="metric-card">
                <div className="metric-label">Total Projects</div>
                <div className="metric-value">{metrics.totalProjects}</div>
              </div>
              <div className="metric-card">
                <div className="metric-label">Total Runs</div>
                <div className="metric-value">{metrics.totalRuns}</div>
              </div>
              <div className="metric-card">
                <div className="metric-label">Active Runs</div>
                <div className="metric-value">{metrics.activeRuns}</div>
              </div>
              <div className="metric-card">
                <div className="metric-label">Pass Rate</div>
                <div className="metric-value metric-value-accent">{metrics.passRate}%</div>
              </div>
            </div>
          </div>
        )}

        {/* Projects below overview */}
        <div className="dashboard-projects-col">
          <h2 className="col-heading">Projects</h2>
          {loading ? (
            <div className="loading">Loading projects...</div>
          ) : projects.length === 0 ? (
            <div className="empty-state">
              <p>No projects yet. Create one to get started!</p>
            </div>
          ) : (
            <div className="projects-list">
              {projects.map((project) => (
                <div key={project.id} className="project-row">
                  <div className="project-row-main">
                    <div className="project-row-name">{project.name}</div>
                    <div className="project-row-desc">{project.description || 'No description'}</div>
                  </div>
                  <Link to={`/projects/${project.id}`} className="btn btn-secondary btn-small project-row-open">
                    Open
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
